import React from "react";

import { isAfterEffectsAsset } from "utils/Assets";

export function DownloadAssets(props) {
	const { iconInfo, data, timestamp, prettyTime, clearMessage } = props;
	let { icon, title } = iconInfo || {};
	let { fileName, libraryName, assetType } = data || {};
	let messageAssetType = `${assetType}s`;

	if(assetType.toLowerCase() === "audio"){
		messageAssetType = assetType;
	} else if(isAfterEffectsAsset(assetType)){
		messageAssetType = "After Effects Package";
	}

	let message = "Download Attempt";
	let clear = <i key="clear" className="ft-ic fal fa-times clear-message" title="Clear Message" onClick={clearMessage} />;

	if (/in progress/gi.test(title)) {
		icon = "fas fa-cloud-download";
		message = `Download in progress - ${messageAssetType}.`;
		clear = <b key="clear" />;
	} else if (/success/gi.test(title)) {
		message = `Download completed - ${messageAssetType}.`;
	} else if (/failed/gi.test(title)) {
		message = `Download failed - ${messageAssetType}.`;
	}

	return [
		<i key="status-icon" className={`ft-ic status-icon ${icon}`} title={title} />
		, <div key="body" className="message-body">
			<b>{message}</b>
			<p>{fileName}</p>
		</div>
		, clear
		, <b key="empty" />
		, <span key="footer" className="message-footer name-overflow" title={libraryName}>{libraryName}</span>
		, <time key="time" className="message-time" dateTime={timestamp}>{prettyTime}</time>
	];
}
